<template>
  <div v-if="user != ''" class="wrapper">
    <HTMLHeader></HTMLHeader>

    <div class="subpage-head-image" style="background-image: url('assets/img/subpage-head.jpg');">
      <div class="container">
        <h1>
          Kapcsolat
          <span>Vegye fel velünk a kapcsolatot</span>
        </h1>
      </div>
    </div>

    <section>
      <div class="container">
        <ul class="ordered-list with-icon">
          <li><i class="fa fa-map-marker"></i><span class="highlight">Cím:</span> Győr, Egyetem tér 1.</li>
          <li><i class="fa fa-phone"></i><span class="highlight">Telefon:</span> +36 96 555 666</li>
          <li><i class="fa fa-envelope"></i><span class="highlight">Email:</span> info@sze.hu</li>
          <li><i class="fa fa-user"></i><span class="highlight">Adatvédelmi felelős:</span> Nagy Viktor (nv@sze.hu)</li>
        </ul>
      </div>
    </section>

    <HTMLFooter></HTMLFooter>
    <ProfileMenu></ProfileMenu>
  </div>
</template>
<script>
import Vue from 'vue';
import HTMLHeader from './tpl_header.vue';
import HTMLFooter from './tpl_footer.vue';
import ProfileMenu from './tpl_profile_menu.vue';

export default {
  components: {
    HTMLHeader,
    HTMLFooter,
    ProfileMenu
  },
  data: function() {
    return {
      sent: false
    }
  },
  mounted: function() {
    var _this = this;
    Vue.nextTick(function() {
      $('.subpage-head-image').height($(window).innerHeight() * .25);
      $(window).scrollTop(0);

      setHeaderDarkLine();

      $(window).resize(function() {
        setHeaderDarkLine();
      });
    });
  },
  methods: {
  }
}

</script>




// WEBPACK FOOTER //
// contact.vue?575006f2